import list from './list'
import playback from './playback'

const calendar = {
  path: 'calendar',
  component: resolve => require(['../../../../pages/teacher/course/calendar'], resolve),
  redirect: 'calendar/list',
  children: [
    list,
    playback
  ]
}
export default calendar



// WEBPACK FOOTER //
// ./src/router/teacher/course/calendar/index.js